import { Box, Button, Link, Typography } from "@mui/material";
import { red } from "@mui/material/colors";
import { BrandsContext } from "contexts/Brands";
import { useContext } from "react";
import { BentoBrand } from "schemas/dashboard";
import { CustomEvent } from "schemas/functions";

import { trackEvent } from "utils/tracking";

const styles = {
  clamped: {
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 2,
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  expanded: {
    whiteSpace: "normal",
  },
};

export default function AboutSummary({
  bentoBrand,
  expanded,
}: {
  bentoBrand: BentoBrand;
  expanded: boolean;
}) {
  const { setOpenReportInfoDialog } = useContext(BrandsContext);

  if (!bentoBrand.aboutSummary) return <></>;

  return (
    <>
      <Typography
        color="textSecondary"
        sx={{
          fontSize: 12,
          mb: 0,
          ...(expanded ? styles.expanded : styles.clamped),
        }}
      >
        {bentoBrand.aboutSummary}
      </Typography>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 1 }}
      >
        <Link
          sx={{
            textDecoration: "underline",
            fontWeight: 600,
            fontSize: 12,
            display: "inline-flex",
            alignItems: "center",
            cursor: "pointer",
          }}
        >
          {expanded ? "View Less" : "Learn More"}
        </Link>
        <Button
          size="small"
          color="error"
          sx={{
            fontSize: 10,
            color: red[300],
            textTransform: "none",
          }}
          onClick={(e: CustomEvent) => {
            e.stopPropagation();
            trackEvent("Wrong Info Brand Card Button Clicked", {
              "Bento Brand ID": bentoBrand.id,
            });
            setOpenReportInfoDialog(bentoBrand);
          }}
        >
          <Box
            component="span"
            className={`fa-solid fa-solid fa-triangle-exclamation`}
            sx={{ mr: 0.5 }}
          />
          Flag Info
        </Button>
      </Box>
    </>
  );
}
